import { render, staticRenderFns } from "./Delta.vue?vue&type=template&id=16f75690"
import script from "./Delta.vue?vue&type=script&lang=js"
export * from "./Delta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports